/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { TabContainer, Tab, Nav, Form } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import favoriteService from 'service/favorite';
import defCashImg from 'assets/img/icons/def-cash-img.png';
import { ElipceIcon } from 'assets/img/icons/icons';

import './featureProducts.scss';
import Button from 'components/base/Button';

interface FeaturedProductsTableProps {
  setCashBackListData?: any;
  setOpenFeaturedProducts: (show: boolean) => void;
  cashBackListData?: any;
}

const FeaturedProductsTable = ({
  setCashBackListData,
  setOpenFeaturedProducts,
  cashBackListData
}: FeaturedProductsTableProps) => {
  const { t } = useTranslation();

  const [key, setKey] = useState<any>(null);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  const { data: favoriteCatalogsData } = useQuery(
    ['GET_FAVORITE_CATALOGS'],
    () => {
      const res = favoriteService
        .getList({
          offset: 0,
          limit: 100
        })
        .then((res: any) => res?.catalogs);
      return res;
    }
  );

  useEffect(() => {
    if (favoriteCatalogsData && favoriteCatalogsData.length > 0 && !key) {
      setKey(favoriteCatalogsData[0].pid);
    }
  }, [favoriteCatalogsData, key]);

  const { data: favoriteCatalogsItemsData } = useQuery(
    ['GET_FAVORITE_CATALOGS_ITEMS', key],
    () => {
      if (key) {
        const res = favoriteService
          .getFavoriteCatalogItemsById(key)
          .then((res: any) => res?.items);
        return res;
      }
    },
    { enabled: !!key }
  );

  const handleSwitchChange = (product: any) => {
    setSelectedItems(prev => {
      if (prev.some(item => item.pid === product.pid)) {
        return prev.filter(item => item.pid !== product.pid);
      }
      return [...prev, product];
    });
  };

  const handleApply = () => {
    setCashBackListData((prev: any) => {
      const newItems = selectedItems.filter(
        (item: any) => !prev.some((existing: any) => existing.pid === item.pid)
      );
      return [...prev, ...newItems];
    });
    setOpenFeaturedProducts(false);
  };

  const uniqueItemsData = favoriteCatalogsItemsData?.filter(
    (product: any, index: any, self: any) =>
      index ===
      self.findIndex((p: any) => p?.product?.pid === product?.product?.pid)
  );

  return (
    <div className="feature-container">
      <TabContainer activeKey={key} onSelect={k => setKey(k)}>
        <Nav variant="underline" className="mb-3">
          {favoriteCatalogsData?.map((items: any) => (
            <Nav.Item key={items?.pid}>
              <Nav.Link eventKey={items?.pid}>{items?.name}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <Tab.Content>
          {favoriteCatalogsData?.length > 0
            ? favoriteCatalogsData?.map((item: any) => (
                <Tab.Pane key={item?.pid} eventKey={item?.pid}>
                  <div className="tab-body">
                    {uniqueItemsData?.map((products: any) => {
                      const isInCashBackList = cashBackListData?.some(
                        (item: any) => item?.pid === products?.product?.pid
                      );
                      return (
                        <div key={products?.pid} className="tab-body-items">
                          <div className="file-thumbnail">
                            <img
                              className="fit-cover"
                              src={
                                products?.product?.photo
                                  ? products?.product?.photo
                                  : defCashImg
                              }
                            />
                          </div>

                          <div className="flex-1">
                            <h6 className="product-name">
                              {products?.product?.name || ''}
                            </h6>
                            <p className="mb-0 d-flex gap-2 align-items-center">
                              <span className="cash-cost">
                                {products?.product?.price
                                  ? new Intl.NumberFormat('en-US', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 4,
                                      useGrouping: true
                                    })
                                      .format(products?.product?.price)
                                      .replace(/,/g, ' ')
                                  : 0}
                              </span>
                              <ElipceIcon />
                              <span className="cash-remainder">
                                {t('remaining_cash')}{' '}
                                {products?.quantity_left || 0}
                              </span>
                            </p>
                          </div>

                          <div className="table-body-items-switch">
                            <Form.Check
                              type="checkbox"
                              checked={
                                isInCashBackList ||
                                selectedItems.some(
                                  item => item?.pid === products?.product?.pid
                                )
                              }
                              onChange={() =>
                                handleSwitchChange(products?.product)
                              }
                              disabled={isInCashBackList}
                              className="mt-auto"
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Tab.Pane>
              ))
            : null}
        </Tab.Content>
      </TabContainer>

      {favoriteCatalogsItemsData?.length > 0 && (
        <div className="btns">
          <Button
            variant="secondary"
            onClick={() => setOpenFeaturedProducts(false)}
          >
            {t('cansel')}{' '}
          </Button>
          <Button
            disabled={selectedItems.length === 0}
            variant="primary"
            onClick={handleApply}
          >
            {t('apply')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default FeaturedProductsTable;
